module.exports = __webpack_public_path__ + "img/sgplhc_bg.08a73714.png";